import {config} from "../environment";
import {useAsync} from "../utils/utils";

type InnloggetBruker = {
  ident: string
  navn: {
    fornavn: string
    mellomnavn: string
    etternavn: string
    fulltNavn: string
  }
}

async function getInnloggetBruker(): Promise<InnloggetBruker> {
  return fetch(`${config.apiUrl}/api/innlogget-bruker`)
  .then(res => res.json() as Promise<InnloggetBruker>)
}

export const useInnloggetBruker = useAsync(getInnloggetBruker)
